<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Processo Judicial"
                @click.stop="abrirModal()"
            ></i>
        </span>
		<b-modal
			v-model="showModal"
			id="modalAtualizarProcesso"
			hide-footer
		>
			<div slot="modal-title">
				Processo Judicial -
				<b-badge variant="warning">Atualizar</b-badge>
			</div>
			<processos-judiciais-form
				tipoOperacao="a"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterProcessosAtualizados="$emit('obterProcessosAtualizados')"
				:processo="processo"
				:contrato="contrato"
			></processos-judiciais-form>
		</b-modal>
    </div>
</template>

<script>
import ProcessosJudiciaisForm from './ProcessosJudiciaisForm'

export default {
	components: {
		ProcessosJudiciaisForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		processo: {
			type: Object,
			default: () => ({})
		},
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
